import { useCommentStore } from "../../../../stores/commentStore";

const DEFAULT_SUPPRESSION_MS = 1000;

/**
 * Suppresses EditorContainer midline comment-card sync during Story Bible
 * programmatic scrolling. The 1000ms window covers a single smooth scroll
 * animation on long documents. Call before each scrollIntoView or at the
 * start of each poll/retry iteration so the window re-arms across the
 * full navigation duration.
 *
 * Does not shorten an existing longer suppression (e.g., the 2000ms
 * window set by comment deletion).
 */
export function suppressCommentSyncForStoryBibleNav(durationMs: number = DEFAULT_SUPPRESSION_MS): void {
  const store = useCommentStore.getState();
  const current = store.commentScrollSyncSuppressedUntil ?? 0;
  const next = Date.now() + durationMs;
  if (next > current) {
    store.setCommentScrollSyncSuppressedUntil(next);
  }
}
